module.exports = __webpack_public_path__ + "img/lv9.bcff4082.png";